module.exports = __webpack_public_path__ + "static/img/gauge.f60187c.png";


//////////////////
// WEBPACK FOOTER
// ./static/gauge.png
// module id = hqi8
// module chunks = 1